import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
export var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);
    this.cbCache = void 0;
    this.cbCache = {};
  }
  _createClass(EventEmitter, [{
    key: "on",
    value: function on(event, fn) {
      if (!this.cbCache[event]) {
        this.cbCache[event] = [];
      }
      this.cbCache[event].push(fn);
      return this;
    }
  }, {
    key: "once",
    value: function once(event, fn) {
      var _this = this;
      var wrap = function wrap() {
        _this.off(event, wrap);
        for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
          rest[_key] = arguments[_key];
        }
        fn.apply(_this, rest);
      };
      wrap.fn = fn;
      this.on(event, wrap);
      return this;
    }
  }, {
    key: "off",
    value: function off(event, fn) {
      var fns = this.cbCache[event];
      if (!fns) {
        return false;
      }
      if (!fn) {
        this.cbCache[event] = [];
      } else {
        // @ts-ignore
        this.cbCache[event] = this.cbCache[event].filter(function (cb) {
          return cb !== fn && cb.fn !== fn;
        });
      }
      return this;
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var fns = this.cbCache[event];
      if (fns) {
        for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          rest[_key2 - 1] = arguments[_key2];
        }
        var _iterator = _createForOfIteratorHelper(fns),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var fn = _step.value;
            fn.apply(this, rest);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return this;
    }
  }]);
  return EventEmitter;
}();